import React, { useState, useEffect } from "react";
import { FaLinkedin, FaInstagram, FaYoutube } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import "./InstructorCarousel.css";

// Import images
import instructor1 from "../Component/Nishant.jpg";
import instructor2 from "../Component/Ujjwal pandey.jpg";

const instructors = [
  { id: 1, name: "Nishant Srivastava", role: "MCA (Gold Medalist), Computer Science Faculty", image: instructor1 },
  { id: 2, name: "Ujjawal Pandey", role: "Tally Communication Instructor", image: instructor2 },
  // { id: 3, name: "Anjali Mishra", role: "ADCA / Advanced Excel Specialist", image: instructor3 },
  // { id: 4, name: "Priya Gupta", role: "Tally Prime / GST Trainer", image: instructor4 },
  // { id: 5, name: "Kavya Sharma", role: "CCC / Office Automation Trainer", image: instructor5 },
  // { id: 6, name: "Sakshi Patel", role: "Graphic & Digital Design Coach", image: instructor6 },
];

const InstructorCarousel = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const prevSlide = () => {
    setCurrentIndex((prev) =>
      prev === 0 ? instructors.length - 1 : prev - 1
    );
  };

  const nextSlide = () => {
    setCurrentIndex((prev) =>
      prev === instructors.length - 1 ? 0 : prev + 1
    );
  };

  // Auto-slide every 2 sec
  useEffect(() => {
    const interval = setInterval(() => {
      nextSlide();
    }, 2000);
    return () => clearInterval(interval);
  }, []);

  // ⭐ Dynamic visible cards — 2 instructors → 2 cards, 3+ instructors → 3 cards
  const cardsToShow = instructors.length >= 3 ? 3 : instructors.length;

  const visibleInstructors = Array.from({ length: cardsToShow }, (_, i) => {
    return instructors[(currentIndex + i) % instructors.length];
  });

  return (
    <section className="instructor-section">
      <p className="instructor-subtitle">INSTRUCTORS</p>
      <h2 className="instructor-title">Meet Our Instructors</h2>

      <div className="carousel-container">
        <button className="carousel-btn left" onClick={prevSlide}>❮</button>

        <div className="carousel-wrapper">
          {visibleInstructors.map((inst) => (
            <div key={inst.id} className="instructor-card">
              <img src={inst.image} alt={inst.name} className="instructor-img" />
              <div className="instructor-info">
                <h3>{inst.name}</h3>
                <p>{inst.role}</p>
                {/* <div className="social-icons">
                  <a href="#"><FaXTwitter /></a>
                  <a href="#"><FaLinkedin /></a>
                  <a href="#"><FaInstagram /></a>
                  <a href="#"><FaYoutube /></a>
                </div> */}
              </div>
            </div>
          ))}
        </div>

        <button className="carousel-btn right" onClick={nextSlide}>❯</button>
      </div>
    </section>
  );
};

export default InstructorCarousel;
